import {MetricsRequest} from 'common/react-query/metrics/types';

export const METRICS_REQUEST_STALE_TIME = 5 * 60 * 1000; // 5 minutes

export const METRICS_NODE_KEY = `metricsNode`;

// DO NOT pass in nodeId here.
// for same request params, react-query will dedupe queries that are identical
export function metricsNodeQueryKeyPrefix(request: MetricsRequest) {
  return [METRICS_NODE_KEY, request];
}

export const CANVASES_KEY = `canvases`;

export function canvasQueryKeyPrefix(canvasId: string) {
  return [CANVASES_KEY, canvasId];
}
